import {useEffect, useRef, useState} from "react";
import {LookupItemModel, LookupKeyValueModel, LookupTypeEnum, SearchAccountsSampleRequestModel} from "../../../models";
import {getLookupByType} from "../../../serviceBroker/lookupApiServiceBroker";

export const useJournalVoucher=()=>{
    //#region states
    const [loading, setLoading] = useState(false);
    const [accountsLoading, setAccountsLoading] = useState(false);
    const [userLookUps, setUserLookUps] = useState<LookupItemModel[]>([]);
    const [currencyLookUps, setCurrencyLookUps] = useState<LookupItemModel[]>([]);
    const [coastCenterLookUps, setCoastCenterLookUps] = useState<LookupItemModel[]>([]);
    const [accountLookups, setAccountLookups] = useState<LookupItemModel[]>([]);
    const [storedEmployeeList, setStoreEmployeeList] = useState<LookupItemModel[]>([]);
    const [accountsFilter, setAccountsFilter] = useState<SearchAccountsSampleRequestModel>({
        pageNumber: 0,
        pageSize: 100,
        accountName: null,
        accountCode: null,
        accountId: null,
        userId: null,
        parentId: null
    });
    const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    //#endregion
    //#region functions
    const getAllLookups = async () => {
        const [users, currencies, coastCenters, employees] = await Promise.all([
            getLookupByType(LookupTypeEnum.Users, true, false),
            getLookupByType(LookupTypeEnum.Currency, true, false),
            getLookupByType(LookupTypeEnum.CostCenters, true, false),
            //getLookupByType(LookupTypeEnum.AllAccountsPagination, false, false,[{key:"pageNumber",value:"0"},{key:"pageSize",value:"10"}]),
            getLookupByType(LookupTypeEnum.Employee, false, false),
        ]);

       //setAccountLookups(accounts);
        setUserLookUps(users);
        setCurrencyLookUps(currencies);
        setCoastCenterLookUps(coastCenters);
        setStoreEmployeeList(employees);
    }
    const getAccounts = async (filterParams = accountsFilter) => {
        setAccountsLoading(true);
        const params:LookupKeyValueModel[] = [
            {key: "pageNumber", value:filterParams.pageNumber?.toString()??"0"},
            {key: "pageSize", value: filterParams.pageSize?.toString()??"100"}

        ];
        if (filterParams.accountName) {
            params.push({key: "accountName", value: filterParams.accountName});
        }

        const accounts = await getLookupByType(
            LookupTypeEnum.AllAccountsPagination,
            false,
            false,
            params
        );

        setAccountLookups(accounts);
        setAccountsLoading(false);
    }
    const updateAccountsFilter = async (newFilterValues: Partial<SearchAccountsSampleRequestModel>) => {
        // If changing search criteria or filters, reset to first page
        const resetPage = (newFilterValues.accountName !== undefined ||
                newFilterValues.accountCode !== undefined ||
                newFilterValues.accountId !== undefined ||
                newFilterValues.userId !== undefined ||
                newFilterValues.parentId !== undefined) &&
            !newFilterValues.pageNumber;

        const updatedFilter = {
            ...accountsFilter,
            ...newFilterValues,
            // Reset page number when search/filter criteria change
            ...(resetPage ? {pageNumber: 0} : {})
        };

        setAccountsFilter(updatedFilter);
        await getAccounts(updatedFilter);
    }
    const searchAccounts = (searchTerm: string) => {
        // Clear any existing timeout
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        // Set a new timeout
        searchTimeoutRef.current = setTimeout(async () => {
            await updateAccountsFilter({
                accountName: searchTerm || null,
                // Reset to first page on search
                pageNumber: 0
            });
        }, 300); // 300ms debounce delay
    };
    //#endregion
    //#region useEffects
    useEffect(() => {
        const fillData = async () => {
            setLoading(true);
            await Promise.all([
                getAllLookups(),
                getAccounts()
            ]);
            setLoading(false);
        };
        fillData().then(() => {});
        // Cleanup timeout on unmount
        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, []);
    //#endregion
    //#region return
    return {
        // States
        loading,
        setLoading,
        accounts:accountLookups,
        storedCurrencies: currencyLookUps,
        costCenters: coastCenterLookUps,
        storedEmployeeList,
        userLookUps,
        accountsFilter,
        // Functions
        updateAccountsFilter,
        refreshAccounts: getAccounts,
        searchAccounts,
    };
    //#endregion
}